import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

import IconSearch from "./search.svg";

type ContainerProps = ResponsiveStyledProps;

export const Container = styled.div<ContainerProps>`
  position: relative;

  ${responsiveStyles}
`;

export const SearchBarContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;

  inline-size: 240px;
  block-size: 32px;
  padding: 3px;

  border: 1px solid #dfdfdf;
  border-radius: 100px;

  background-color: #f8f8f8;
`;

export const SearchIconButton = styled.button`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;

  inline-size: 26px;
  block-size: 26px;
  padding: 0;

  border: 0;
  border-radius: 50%;

  background-color: #556bb4;

  cursor: pointer;
`;

export const SearchIcon = styled(IconSearch)`
  inline-size: 17px;
  block-size: 17px;
`;

export const SearchBarInput = styled.input`
  flex: 1;

  min-inline-size: 0;
  padding-inline-start: 4px;
  box-sizing: border-box;

  color: #333333;
  font-weight: 400;
  font-size: 13px;
  font-family: ${fontRoboto};
  line-height: normal;

  border: 0;

  background-color: transparent;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: #999999;
  }
`;

export const TooltipTarget = styled.div`
  position: absolute;
  inset-inline-start: 20px;
  z-index: -1;

  inline-size: 32px;
  block-size: 32px;
`;
